import "@pws/coquille-ui/styles.css";
import { EmptyState as CoquilleEmptyState } from "@pws/coquille-ui";
import { injectCoquilleTokens } from "./injectCoquilleTokens.js";

injectCoquilleTokens();

export { CoquilleEmptyState as EmptyState };
